import { createContext } from "react";

const ColegioContext = createContext();

export default ColegioContext;
